import { NotFoundError } from '@cian/peperrors';

import { ResponseError } from '../../errors';
import { InvalidLocationError } from '../../errors/InvalidLocationError';
import { prepareOffers } from '../../mappers/prepareOffers';
import {
  fetchSearchOffersDesktop,
  TSearchOffersDesktopResponse,
} from '../../repositories/search-offers/v2/search-offers-desktop';
import { IApplicationContext } from '../../types/applicationContext';
import { IOffersData } from '../../types/offersData';

interface IFetchOffersPathParameters {
  subdomain: string;
  path: string;
}

interface IFetchOffersJsonQueryParameters {
  // oxlint-disable-next-line typescript/no-explicit-any
  jsonQuery: any;
}

interface IFetchOffersLiquiditySourceParameters {
  liquiditySource?: string;
}

type TFetchOffersParameters = (IFetchOffersPathParameters | IFetchOffersJsonQueryParameters) &
  IFetchOffersLiquiditySourceParameters;

export async function fetchOffers(
  { httpApi }: IApplicationContext,
  _parameters: TFetchOffersParameters,
): Promise<IOffersData> {
  const parameters =
    'jsonQuery' in _parameters
      ? { jsonQuery: _parameters.jsonQuery }
      : { _subdomain: _parameters.subdomain, _path: _parameters.path };

  if (_parameters.liquiditySource) {
    Object.assign(parameters, { _liquiditySource: _parameters.liquiditySource });
  }

  const offersData: TSearchOffersDesktopResponse = await fetchSearchOffersDesktop({
    httpApi,
    parameters,
  });

  if (offersData.statusCode !== 200) {
    // oxlint-disable-next-line typescript/no-explicit-any
    if ((offersData.response.errors?.[0] as any)?.code === 'urlNotFound') {
      throw new NotFoundError({
        domain: 'fetchOffers',
        message: 'URL not found',
        details: {
          errors: JSON.stringify(offersData.response.errors),
        },
      });
    }

    throw new ResponseError({
      domain: 'fetchOffers',
      message: offersData.response.message || '',
      details: {
        errors: JSON.stringify(offersData.response.errors),
      },
    });
  }

  if (offersData.response.data.redirectData) {
    const { redirectData } = offersData.response.data;

    if (!redirectData.location || !redirectData.statusCode) {
      throw new ResponseError({
        domain: 'fetchOffers',
        message: 'Неверный формат redirectData',
        details: {
          // oxlint-disable-next-line typescript/no-explicit-any
          redirectData: redirectData as any,
        },
      });
    }

    throw new InvalidLocationError({
      domain: 'fetchOffers',
      message: 'В ответе API пришёл редирект',
      details: {
        redirectStatusCode: redirectData.statusCode as 301 | 302,
        redirectLocation: redirectData.location,
      },
    });
  }

  return prepareOffers(offersData.response);
}
